import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const LEGAL = {
  privacy: {
    title: "Privacy policy",
    body: [
      "We collect only what is needed to manage your booking: your full name, email address, WhatsApp number, country of residence, and — only if you choose to share them — an investment budget range and your question.",
      "This information is used to confirm, prepare for, and contact you about your briefing. It is never sold or shared with third parties for marketing.",
      "Registrations are stored in a secure database and can only be viewed by the authorized FAD administrator through a password-protected portal. Booking emails are sent through a transactional email service solely to deliver your appointment details.",
      "To understand how the website is used, we record anonymous visit statistics: approximate country and region (from your time zone or network), time spent on the page, how far you scroll, the type of device and browser, and which website referred you. We do not store your IP address, and this information is not linked to your identity unless you book a briefing.",
      "You may ask for your information to be corrected or deleted at any time by contacting FAD using the details in the footer.",
    ],
  },
  terms: {
    title: "Terms of use",
    body: [
      "This website provides information about a free educational briefing on the Dubai real estate market. Booking a briefing creates no obligation to buy, invest, or use any service.",
      "Please provide accurate details when booking. Appointments may be rescheduled or cancelled by either party; you will be notified by email when a change is made.",
      "Content on this website is for general information only and may change without notice.",
    ],
  },
  disclaimer: {
    title: "Educational & investment-risk disclaimer",
    body: [
      "The briefing and all website content are educational and do not constitute financial, legal, or tax advice. Consider independent professional advice before making an investment decision.",
      "Property investments carry risk. Rental income and capital appreciation are not guaranteed, and values can fall as well as rise.",
      "Monetary figures are shown in US dollars (USD) as reference conversions and are estimates. The actual payment currency, exchange rates, fees, and transaction costs may differ.",
    ],
  },
};

export function LegalDialog({ kind, onClose }) {
  const doc = kind ? LEGAL[kind] : null;
  return (
    <Dialog open={!!doc} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg rounded-3xl" data-testid="legal-dialog">
        {doc && (
          <>
            <DialogHeader>
              <DialogTitle className="font-display text-2xl text-[#0B1F3A]">{doc.title}</DialogTitle>
              <DialogDescription className="sr-only">{doc.title}</DialogDescription>
            </DialogHeader>
            <div className="space-y-4 text-[15px] leading-relaxed text-[#697386] max-h-[60vh] overflow-y-auto">
              {doc.body.map((p) => (
                <p key={p}>{p}</p>
              ))}
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
